import { Component } from '@angular/core';

/** Loading placeholder shaped like this page: three metric cards and one funnel card. */
@Component({
  selector: 'ifbp-pipeline-health-skeleton',
  templateUrl: './pipeline-health-skeleton.component.html',
  styleUrls: ['./pipeline-health-skeleton.component.scss'],
  standalone: false,
})
export class PipelineHealthSkeletonComponent {
  readonly cards = [0, 1, 2];
  readonly cardTheme = { height: '8rem', 'border-radius': '1rem', margin: 0 };
  readonly funnelTheme = { height: '19.75rem', 'border-radius': '0.75rem', margin: 0 };

  trackByIndex(index: number): number {
    return index;
  }
}
